import React from 'react';
import classnames from 'classnames';
import LoadingPanel from '../../../../../components/LoadingPanel';
import HardwareList from './HardwareList';

const ChatUrl = "https://www.rikstv.no/kundeservice/chat/";

const HardwareResults = (props) => {
    const {
        productData: {
            isLoading,
            list,
            notEligibleToMove,
            addHardwareInfo
        },
        titleText = 'Funnet',
        notFoundText =  <span>Serienummer finnes ikke. Vennligst sjekk at du har rett serienummer. Hvis du er sikker på at det er rett og det ikke virker så må du ta kontakt med oss
                            <a href={ChatUrl}>her</a>.
                        </span>,
        notEligableText = <span>Dette utstyret kunne ikke flyttes - {addHardwareInfo.reason} </span>
    } = props;    

    // Error message & classes
    const hasError = !!addHardwareInfo.reason;
    const errorClass = classnames('alert', { 'alert-danger' : addHardwareInfo.isBlocked, 'alert-warning': !addHardwareInfo.isBlocked });    
    return (
        <div className="hardware-results">
            <h2 className="summary-title">{titleText}</h2>
            {isLoading &&
                <LoadingPanel />
            }
            {!isLoading &&
                <div>
                    <HardwareList hardwareList={list} className='compact-list' />
                    {list.length === 0 &&
                        <div className="alert alert-danger">
                            {notEligibleToMove ?
                                <div>{notEligableText}</div>
                                : <div>{notFoundText}</div>
                            }
                        </div>
                    }
                    {hasError &&
                        <div className={errorClass}>
                            {notEligableText}
                        </div>
                    }
                </div>
            }
        </div>
    )
}

export default HardwareResults;